export default __webpack_public_path__ + "static/media/icon-file.28751069.svg";